/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S5_HeadingInputs */

const tr_iletisim_s5_heading = /** @type {(inputs: Iletisim_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurumsal ve İş Birliği`)
};

const en_iletisim_s5_heading = /** @type {(inputs: Iletisim_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corporate and partnerships`)
};

const de_iletisim_s5_heading = /** @type {(inputs: Iletisim_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen und Zusammenarbeit`)
};

const ru_iletisim_s5_heading = /** @type {(inputs: Iletisim_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Корпоративные вопросы и сотрудничество`)
};

/**
* | output |
* | --- |
* | "Corporate and partnerships" |
*
* @param {Iletisim_S5_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s5_heading = /** @type {((inputs?: Iletisim_S5_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S5_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s5_heading(inputs)
	if (locale === "de") return de_iletisim_s5_heading(inputs)
	if (locale === "ru") return ru_iletisim_s5_heading(inputs)
	return tr_iletisim_s5_heading(inputs)
});